import type { Patient, Reference } from '@medplum/fhirtypes'
import { createContext } from 'react'

export const ParticipantReferenceContext = createContext<
  Reference<Patient> | undefined
>(undefined)
